module.exports = __webpack_public_path__ + "static/media/magic.31050656.png";